import {
  gasGetGasList,
  depotGetDepotList,
  oilTypeGetData,
  carGetCarList,
  driverGetDriverList,
  globParmGetGroupAreas,
  groupGetCarteams,
  gasTankGetChooseList,
  companyGetData,
  groupGetData,
  routerOrderRecordGetData,
  dictionary2Get
} from '@/api/api'

import {
  gasDepotPublishGetData
} from '@/api/ycApi'

import {
  dataMap
} from '@/cllib/sys_lib'

import {
  roleGetData,
  menuGetData
} from '@/api/authorityApi'

import {
  dateOperating
} from '@/cllib/tools'

const state = {
  gatePassTypes: [],
  oilTypes: [],
  oilTypesNorm: [{key: '', label: '全部油品'}, {key: '0#', label: '0号车用柴油'}, {key: '92#', label: '92号车用汽油'}, {key: '95#', label: '95号车用汽油'}, {key: '98#', label: '98号车用汽油'}],
  tableSeatchOilTypes: [{key: '0#', label: '0#'}, {key: '92#', label: '92#'}, {key: '95#', label: '95#'}, {key: '98#', label: '98#'}],
  oilBigTypes: [{key: '汽油', label: '汽油'}, {key: '柴油', label: '柴油'}],
  distributionOrderStatus: [{key: 'plan', label: '计划'}, {key: 'way', label: '在途'}, {key: 'end', label: '入库'}],
  globDates: dataMap(),
  htmlFontSize: 0,
  oilDensity: {
    cy: 0.834,
    qy: 0.745
  },
  selectChooseCars: [],
  selectChooseDrivers: [],
  selectChooseGasTanks: [],
  groupAreas: [],
  groupAgents: [],
  selectGasList: [],
  selectDepotList: [],
  selectCompanyList: [],
  selectCompanys: [],
  selectCarTeamList: [],
  selectGroupList: [],
  selectMenus: [],
  selectRoles: [],
  gasDepotPushLog: [],
  routerOrderStatus: {'sb': false, 'xf': false}
}

const getters = {
  routerOrderStatus: state => state.routerOrderStatus,
  gasDepotPushLog: state => state.gasDepotPushLog,
  tableSeatchOilTypes: state => state.tableSeatchOilTypes,
  oilDensity: state => state.oilDensity,
  globDates: state => state.globDates,
  oilTypesNorm: state => state.oilTypesNorm,
  distributionOrderStatus: state => state.distributionOrderStatus,
  oilTypes: state => state.oilTypes,
  selectChooseGasTanks: state => state.selectChooseGasTanks,
  oilBigTypes: state => state.oilBigTypes,
  htmlFontSize: state => state.htmlFontSize,
  selectChooseCars: state => state.selectChooseCars,
  selectChooseDrivers: state => state.selectChooseDrivers,
  groupAreas: state => state.groupAreas,
  groupAgents: state => state.groupAgents,
  selectGasList: state => state.selectGasList,
  selectDepotList: state => state.selectDepotList,
  selectCompanyList: state => state.selectCompanyList,
  selectCompanys: state => state.selectCompanys,
  selectCarTeamList: state => state.selectCarTeamList,
  selectGroupList: state => state.selectGroupList,
  selectMenus: state => state.selectMenus,
  selectRoles: state => state.selectRoles,
  gatePassTypes: state => state.gatePassTypes
}

const actions = {
  async loadGatePassTypes ({commit, getters}, reload) {
    if (!reload && getters.gatePassTypes.length !== 0) {
      return
    }
    const gatePassTypes = await dictionary2Get({noPage: 1, dicCode: 'car_pass_areas'})
    if (gatePassTypes.length === 1) {
      let str = gatePassTypes[0].dicDesc || ''
      commit('setGatePassTypes', str.split(',').map(v => {
        return {
          label: v,
          key: v,
          data: gatePassTypes[0]
        }
      }))
    }
  },
  loadRouterOrderStatus ({ dispatch, getters }) {
    if (!getters.currentGroupId) {
      return
    }
    let parm = {
      noPage: 1,
      sendTime: getters.globDates.tomorrowStr,
      endTime: dateOperating.computeDay({days: 1, date: getters.globDates.tomorrow, format: 'yy-mm-dd'}),
      groupId: getters.currentGroupId
    }
    return routerOrderRecordGetData(parm).then((data) => {
      let status = {'sb': false, 'xf': false}
      data.forEach((item) => {
        if (item.recordType === '计划下发') {
          status.xf = true
        }
        if (item.recordType === '计划上报') {
          status.sb = true
        }
      })
      dispatch('setRouterOrderStatus', status)
    })
  },
  loadSelectGasList ({ dispatch, getters }) {
    if (getters.selectGasList.length !== 0) {
      return
    }
    let parm = {
      noPage: 1
    }
    return gasGetGasList(parm).then((data) => {
      let newData = []
      data.forEach((item) => {
        if (item.code) {
          newData.push({
            id: item.id,
            name: item.name,
            nameFirstLetter: item.nameFirstLetter,
            code: item.code,
            status: item.status
          })
        }
      })
      dispatch('setSelectGasList', newData)
    })
  },
  loadSelectMenus ({ dispatch, getters }, reload) {
    if (!reload && getters.selectMenus.length !== 0) {
      return
    }
    let parm = {
      noPage: 1
    }
    menuGetData(parm).then((data) => {
      let newData = []
      data.forEach((item) => {
        newData.push({
          key: item.id,
          label: item.name,
          data: item
        })
      })
      dispatch('setSelectMenus', newData)
    })
  },
  loadGasDepotPushLog ({ dispatch, getters }, reload) {
    if (!reload && getters.gasDepotPushLog.length !== 0) {
      return
    }
    let parm = {
      noPage: 1
    }
    gasDepotPublishGetData(parm).then((data) => {
      let newData = []
      data.forEach((item) => {
        newData.push({
          key: item.version,
          label: item.version + (item.publishType === '0' ? '全部发布' : '部分发布') + '(' + (item.publishFlag === '0' ? '地付最优' : '折算运距最优') + ')' + (item.remark ? ':' + item.remark : ''),
          data: item
        })
      })
      dispatch('setGasDepotPushLog', newData)
    })
  },
  loadSelectRoles ({ dispatch, getters }, reload) {
    if (!reload && getters.selectRoles.length !== 0) {
      return
    }
    let parm = {
      noPage: 1
    }
    roleGetData(parm).then((data) => {
      let newData = []
      data.forEach((item) => {
        newData.push({
          key: item.id,
          label: item.name,
          data: item
        })
      })
      dispatch('setSelectRoles', newData)
    })
  },
  loadSelectGroupList ({ dispatch, getters }) {
    if (getters.selectGroupList.length > 0) {
      return
    }
    groupGetData().then((data) => {
      let newData = []
      data.forEach((item) => {
        newData.push({
          key: item.id,
          label: item.name,
          data: item
        })
      })
      dispatch('setSelectGroupList', newData)
    })
  },
  loadSelectChooseGasTanks ({ dispatch, getters }) {
    if (getters.selectChooseGasTanks.length > 0) {
      return
    }
    gasTankGetChooseList(true).then((data) => {
      dispatch('setSelectChooseGasTanks', data)
    })
  },
  loadCompanys ({ dispatch, getters }) {
    if (getters.selectCompanyList.length > 0) {
      return
    }
    companyGetData().then((data) => {
      let newData = []
      data.forEach((item) => {
        newData.push({
          label: item.name,
          key: item.name,
          data: item
        })
      })
      dispatch('setSelectCompanyList', newData)
    })
  },
  setSelectCompanyList ({ commit }, data) {
    commit('setSelectCompanyList', data)
  },
  setRouterOrderStatus ({ commit }, data) {
    commit('setRouterOrderStatus', data)
  },
  setSelectMenus ({ commit }, data) {
    commit('setSelectMenus', data)
  },
  setSelectRoles ({ commit }, data) {
    commit('setSelectRoles', data)
  },
  setSelectGroupList ({ commit }, data) {
    commit('setSelectGroupList', data)
  },
  setSelectChooseGasTanks ({ commit }, data) {
    commit('setSelectChooseGasTanks', data)
  },
  setGasDepotPushLog ({ commit }, data) {
    commit('setGasDepotPushLog', data)
  },
  loadSelectDepotList ({ dispatch, getters }) {
    if (getters.selectDepotList.length > 0) {
      return
    }
    let parm = {
      noPage: 1
    }
    depotGetDepotList(parm).then((data) => {
      let newData = []
      data.forEach((item) => {
        if (item.status === '1') {
          newData.push({
            id: item.id,
            name: item.name,
            data: item
          })
        }
      })
      dispatch('setSelectDepotList', newData)
    })
  },
  setSelectGasList ({ commit }, data) {
    commit('setSelectGasList', data)
  },
  setSelectDepotList ({ commit }, data) {
    commit('setSelectDepotList', data)
  },
  loadChooseCars ({ dispatch }) {
    let parm = {
      noPage: 1
    }
    return carGetCarList(parm).then((data) => {
      let newData = []
      data.forEach((item) => {
        newData.push({key: item.id, label: item.licenseNo, data: item})
      })
      dispatch('setSelectChooseCars', newData)
    })
  },
  loadGroupAreas ({ dispatch, getters }) {
    if (getters.groupAreas.length > 0) {
      return
    }
    globParmGetGroupAreas().then((data) => {
      let newData = []
      data.forEach((item) => {
        newData.push({
          key: item.id,
          label: item.name
        })
      })
      dispatch('setGroupAreas', newData)
    })
  },
  loadGroupAgents ({ dispatch, getters }) {
    if (getters.groupAgents.length > 0) {
      return
    }
    let parm = {
      noPage: 1
    }
    groupGetCarteams(parm).then((data) => {
      let newData = []
      data.forEach((item) => {
        newData.push({
          key: item.id,
          label: item.name,
          data: item
        })
      })
      dispatch('setGroupAgents', newData)
      dispatch('setSelectCarTeamList', newData)
    })
  },
  loadChooseDrivers ({ dispatch }) {
    let parm = {
      noPage: 1
    }
    return driverGetDriverList(parm).then((data) => {
      let newData = []
      data.forEach((item) => {
        newData.push({key: item.id, label: item.name, data: item})
      })
      dispatch('setSelectChooseDrivers', newData)
    })
  },
  loadBusinessParm ({ dispatch }) {
    dispatch('loadCompanys')
    dispatch('loadOilTypes')
    dispatch('loadGroupAreas')
    dispatch('loadGroupAgents')
    dispatch('loadSelectGroupList')
    dispatch('loadSelectDepotList')
  },
  loadOilTypes ({ dispatch, getters }) {
    if (getters.oilTypes.length > 0) {
      return
    }
    return oilTypeGetData().then((data) => {
      let newData = []
      data.forEach((item) => {
        if (item.usable) {
          newData.push({key: item.id, label: item.name, data: item})
        }
      })
      dispatch('setOilTypes', newData)
    })
  },
  initHtmlFontSize ({ commit }) {
    try {
      let fontSize = getComputedStyle(document.getElementsByTagName('html')[0])['font-size']
      commit('setHtmlFontSize', Number(fontSize.replace('px', '')))
    } catch (error) {
      commit('setHtmlFontSize', 16)
      console.log(error)
    }
  },
  setOilTypes ({ commit }, data) {
    commit('setOilTypes', data)
  },
  setSelectCarTeamList ({ commit }, data) {
    commit('setSelectCarTeamList', data)
  },
  setSelectChooseCars ({ commit }, data) {
    commit('setSelectChooseCars', data)
  },
  setSelectChooseDrivers ({ commit }, data) {
    commit('setSelectChooseDrivers', data)
  },
  setGroupAreas ({ commit }, data) {
    commit('setGroupAreas', data)
  },
  setGroupAgents ({ commit }, data) {
    commit('setGroupAgents', data)
  }
}

const mutations = {
  setGatePassTypes (state, data) {
    state.gatePassTypes = data
  },
  setRouterOrderStatus (state, data) {
    state.routerOrderStatus = data
  },
  setSelectMenus (state, data) {
    state.selectMenus = data
  },
  setGasDepotPushLog (state, data) {
    state.gasDepotPushLog = data
  },
  setSelectRoles (state, data) {
    state.selectRoles = data
  },
  setSelectGroupList (state, data) {
    state.selectGroupList = data
  },
  setSelectCompanyList (state, data) {
    state.selectCompanyList = data
    let data2 = []
    data.forEach((item) => {
      data2.push({
        label: item.data.name,
        key: item.data.id
      })
    })
    state.selectCompanys = data2
  },
  setSelectCarTeamList (state, data) {
    state.selectCarTeamList = data
  },
  setSelectGasList (state, data) {
    state.selectGasList = data
  },
  setSelectDepotList (state, data) {
    state.selectDepotList = data
  },
  setSelectChooseGasTanks (state, data) {
    state.selectChooseGasTanks = data
  },
  setOilTypes (state, data) {
    state.oilTypes = data
  },
  setHtmlFontSize (state, data) {
    state.htmlFontSize = data
  },
  setSelectChooseCars (state, data) {
    state.selectChooseCars = data
  },
  setSelectChooseDrivers (state, data) {
    state.selectChooseDrivers = data
  },
  setGroupAreas (state, data) {
    state.groupAreas = data
  },
  setGroupAgents (state, data) {
    state.groupAgents = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/glob_parm.js